"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { theme, pxToEm, pxToRem, themeStyleHelper, mediaQuery } from '../../../utils/styles/index';

/* ++++++++++ --------------- EXPORT : ELLIPSIS : STYLES --------------- ++++++++++ */

var _default = {
  ellipsis: {
    display: 'block',
    // !!!!!! careful, if you have an inline element and wrap it with this ellipsis it may cause unexpected issues
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis' // adds the ...

  }
};
exports.default = _default;